import { MdOutlineManageAccounts } from 'react-icons/md';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const fundManagers = {
  id: 'fundManagers',
  title: '',
  type: 'group',
  children: [
    {
      id: 'fund-managers',
      title: 'Fund Managers',
      type: 'item',
      url: '/fund-managers-list',
      icon: MdOutlineManageAccounts,
      allowedRoles: ['admin', 'superAdmin', 'financeManager', 'complianceOfficer', 'marketingSpecialist'],
      breadcrumbs: false
    }
    // {
    //   id: 'util-color',
    //   title: 'Investing Accounts',
    //   type: 'item',
    //   url: '/utils/util-color',
    //   icon: InvestIcon,
    //   breadcrumbs: false
    // }
    // {
    //   id: 'util-shadow',
    //   title: 'Shadow',
    //   type: 'item',
    //   url: '/utils/util-shadow',
    //   icon: icons.IconShadow,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'icons',
    //   title: 'Icons',
    //   type: 'collapse',
    //   icon: icons.IconWindmill,
    //   children: [
    //     {
    //       id: 'tabler-icons',
    //       title: 'Tabler Icons',
    //       type: 'item',
    //       url: '/icons/tabler-icons',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'material-icons',
    //       title: 'Material Icons',
    //       type: 'item',
    //       external: true,
    //       target: '_blank',
    //       url: 'https://mui.com/material-ui/material-icons/',
    //       breadcrumbs: false
    //     }
    //   ]
    // }
  ]
};

export default fundManagers;
